<div class="factory-bank-details-title">
  <div class="factory-bank-details-title-text">
    {{ data().organizationName || 'Новый' }}
  </div>
  @if (!!data().id && isEditModeActive()) {
    <button
      mat-mini-fab
      class="factory-bank-details-title-btn"
      (click)="handleDelete.emit($event)"
    >
      <mat-icon class="factory-bank-details-title-btn-icon">
        delete
      </mat-icon>
    </button>
  }
</div>
